import { registerScript } from "./external-form-scripts";
import { AutoComplete } from "./lib/autocomplete.lib";

export const initializeGeoAutocomplete = async (formDiv : Element) => {
  const geoAutocomplete : HTMLInputElement = formDiv.querySelector('.gfield--type-zip-to-market-text input');

  if(!geoAutocomplete) {
    return;
  }

  await registerScript('https://maps.googleapis.com/maps/api/js?key=AIzaSyAJhOHfNqT6EKQwBtWob5Kd2k8aBEz4Lu8&libraries=places');
  await AutoComplete(formDiv, geoAutocomplete);

  // Add the missing attributes
  geoAutocomplete.setAttribute('autocomplete', 'off');
}